module.exports = __webpack_public_path__ + "static/media/jung_sheng_chang.3c09ca57.jpg";